

import { defineComponent } from "vue";
import { GlobalThemeOverrides, NConfigProvider, NNotificationProvider, NLoadingBarProvider } from "naive-ui";

import Headbar from '~/components/headbar.vue';
import Footer from '~/components/footer.vue';
import { primaryColor } from "./variables";
import ModalPrompt from "~/components/modals/modal-prompt.vue";
import ModalConfirm from "~/components/modals/modal-confirm.vue";

export default defineComponent({

  components: {
    Headbar,
    Footer,
    NConfigProvider,
    ModalPrompt,
    ModalConfirm,
    NNotificationProvider,
    NLoadingBarProvider
  },

  data() {
    return {
      themeOverride: {
        common: {
          primaryColor: primaryColor,
          fontFamily: 'roboto'
        },
        Button: {
          color: '#ffff'
          
        },
        LoadingBar: {
          height: '4px',
        }
      } as GlobalThemeOverrides ,
      showHeadbar: true,
    }
  },

  watch: {
    $route(to) {
      this.showHeadbar = to.meta.headbar;
    }
  }

});
